import { Pipe, PipeTransform } from '@angular/core';
import { getOrdinal } from '@lx/shared/utils';

@Pipe({
  name: 'lxOrdinal',
  standalone: true,
})
export class OrdinalPipe implements PipeTransform {
  transform(num: string): string {
    return getOrdinal(num);
  }
}
